<template>
  <v-dialog
    v-model="open"
    width="700"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    persistent
    @click:outside="close"
  >
    <v-card v-if="item">
      <v-card-title class="pb-6">
        {{ $t('redemption-history-launch-resend-dialog') }}
      </v-card-title>
      <redeemed-item-details
        :item="item"
        hide-date
      />
      <v-card-text>
        <delivery-status-component
          :status="item.deliveryStatus"
          show-description
        />
      </v-card-text>
      <v-card-text class="grey lighten-4 pa-6">
        <v-row
          dense
          justify="space-between"
          align="center"
        >
          <v-col id="resend-email-address">
            <span>{{
              $t('redemption-history-resend-button-description')
            }}</span>
            <i18n
              path="redemption-history-resend-email-label"
              tag="p"
              class="body-1 mt-2"
            >
              <span class="font-weight-bold">
                {{ item.obfuscatedDeliveryEmailAddress }}
              </span>
            </i18n>
          </v-col>
          <v-col
            cols="12"
            sm="auto"
          >
            <tc-v-btn
              id="resend-reward"
              color="accent"
              class="rounded black--text text-capitalize ml-2"
              x-large
              :loading="loading"
              :disabled="loading"
              @click="resend"
            >
              {{ $t('redemption-history-resend-button-text') }}
            </tc-v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <tc-v-btn
          id="close-resend-reward-dialog"
          color="primary"
          text
          class="text-lowercase"
          @click="close"
        >
          {{ $t('global-button-close') }}
        </tc-v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import * as actionTypes from '@/store/action-types'
import { RedeemedItem } from '@/store/classes/redeemed-item'
import RedeemedItemDetails from '@/components/history/RedeemedItemDetails'
import DeliveryStatusComponent from '@/components/history/DeliveryStatus'
import { ItemDeliveryStatus } from '@/cowboy/EnumTypes'
import * as orderHistoryEvents from '@/plugins/segment/SegmentConstants'
import { NotifyMessage } from '@/service/notification/NotifyMessage'
import { NotificationService } from '@/service/notification/NotificationService'

/**
 * @property {NotificationService} NotificationService
 */
export default {
  name: 'ResendRewardDialog',
  components: {
    DeliveryStatusComponent,
    RedeemedItemDetails
  },
  inject: [NotificationService.provider],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    item: {
      type: RedeemedItem,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    ...mapActions({
      resendReward: actionTypes.RESEND_REWARD
    }),
    close () {
      this.$emit('close')
    },
    async resend () {
      this.$segment.track(orderHistoryEvents.RESEND_BUTTON_CLICKED)
      this.loading = true
      try {
        await this.resendReward(this.item.referenceLineItemId)
        this.item.setDeliveryStatus(ItemDeliveryStatus.PROCESSED)
        this.NotificationService.push(NotifyMessage.info({
          message: this.$t('redemption-history-resend-success')
        }))
      } catch (e) {
        this.NotificationService.push(NotifyMessage.error({
          message: this.$t('redemption-history-resend-error')
        }))
      } finally {
        this.loading = false
        this.close()
      }
    }
  }
}
</script>
